import api from '../axios';

export const getCosts = (projectId, construction_type, page, page_size) =>
  api.get(`contract/cost/${projectId}/`, { 
    params: { construction_type, page, page_size } 
  }).then(res => res.data);

// 계약 상세 조회
export const getCostDetail = (costId) =>
  api.get(`contract/cost/detail/${costId}/`)
     .then(res => res.data);

// 계약 생성 (파일 포함 가능)
export const createCost = (data) =>
  api.post('contract/cost/create/', data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);

// 계약 수정 (파일 포함 가능)
export const updateCost = (costId, data) =>
  api.put(`contract/cost/update/${costId}/`, data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);

// 계약 삭제
export const deleteCost = (costId) =>
  api.delete(`contract/cost/delete/${costId}/`)
     .then(res => res.data);